var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"twitter-follow-button",attrs:{"href":"https://twitter.com/MemCachier","data-show-count":"false"}},[_vm._v(" Follow @MemCachier ")])}
var staticRenderFns = []

export { render, staticRenderFns }